<template>
  <div
    class="px-10 min-h-[calc(100vh_-_90px)] sm:h-[calc(100vh_-_90px)] overflow-x-hidden bg-white"
  >
    <div
      class="container max-w-[1200px] mx-auto flex flex-wrap items-center sm:min-h-[calc(100vh_-_90px)]"
    >
      <div class="py-10 w-full text-center">
        <div class="bg-chateauGreen-100 rounded-3xl pt-[5em] pb-40 px-10">
          <h1 class="text-3xl sm:text-5xl/[60px] font-bold mt-2 mb-5">
            Elevate Your AI Experiences with CSV RAG
          </h1>
          <p class="text-xl text-chateauGreen-800">
            Quickly turn your static CSV files into powerful RAG applications with advanced search and chat capabilities.
          </p>
        </div>
        <div class="-mt-40">
          <div class="flex flex-wrap my-10 items-stretch">
            <div class="w-full md:w-1/2 lg:w-1/3 px-5 my-5">
              <div class="rounded-3xl shadow-lg px-8 py-8 text-center bg-white">
                <div class="bg-chateauGreen-200 rounded-full w-16 h-16 mx-auto mb-5 flex items-center justify-center text-3xl text-chateauGreen">
                  1
                </div>
                <h3 class="text-2xl font-bold">Upload</h3>
                <p class="text-lg text-alto-500 mt-3">
                  Easily upload your CSV files and select which columns should be searchable by similarity.
                </p>
              </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-5 my-5">
              <div class="rounded-3xl shadow-lg px-8 py-8 text-center bg-white">
                <div class="bg-chateauGreen-200 rounded-full w-16 h-16 mx-auto mb-5 flex items-center justify-center text-3xl text-chateauGreen">
                  2
                </div>
                <h3 class="text-2xl font-bold">Interact</h3>
                <p class="text-lg text-alto-500 mt-3">
                  Ask questions and chat with your CSV data through our intuitive interface.
                </p>
              </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-5 my-5">
              <div class="rounded-3xl shadow-lg px-8 py-8 text-center bg-white">
                <div class="bg-chateauGreen-200 rounded-full w-16 h-16 mx-auto mb-5 flex items-center justify-center text-3xl text-chateauGreen">
                  3
                </div>
                <h3 class="text-2xl font-bold">Build</h3>
                <p class="text-lg text-alto-500 mt-3">
                  Use our APIs and widgets to create custom experiences for your customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
    };
  },
  mounted() {
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>
